import { cn } from '@reelplicate/ui/lib/utils';
import * as React from 'react';

/**
 * shadcn Textarea, restyled to the Figma "Text Area" component set (page ↳
 * Inputs): 120px (≈4 lines) by default, grows with content up to 320px, then
 * scrolls. Apps use `TextArea` (components/lib), which adds Field wiring. The
 * resize handle is drawn in globals.css.
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'field-sizing-content flex max-h-80 min-h-30 w-full resize-y rounded-md border border-border-strong bg-bg-surface p-3',
        'text-body-md text-text-primary outline-none placeholder:text-text-tertiary selection:bg-brand-subtle',
        'transition-[border-color,box-shadow] duration-[120ms] ease-out',
        'hover:border-border-strong-hover',
        // Focus: 1.5px border/focus stroke (1px border + 0.5px inset ring, so
        // nothing shifts) + Focus/Input halo.
        'focus-visible:border-border-focus focus-visible:shadow-focus-input focus-visible:inset-ring-[0.5px] focus-visible:inset-ring-border-focus',
        'aria-invalid:border-status-danger-fg aria-invalid:inset-ring-[0.5px] aria-invalid:inset-ring-status-danger-fg',
        'disabled:cursor-not-allowed disabled:border-border-default disabled:bg-bg-disabled disabled:text-text-disabled disabled:placeholder:text-text-disabled',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
